import { useState } from 'react';
import { Timestamp } from 'firebase/firestore';
import { BaseModal } from '@/components/shared';
import type { EstadiaCliente } from '../../../models';
import { useEstadiaClienteMutations } from '../../../hooks/data';
import { dataInputParaDate } from '../../../utils/dataInput';

interface ConfirmarChegadaModalProps {
  isOpen: boolean;
  onClose: () => void;
  estadia: EstadiaCliente;
}

/**
 * Confirma que o equipamento chegou no Cliente (em_transito -> em_homologacao),
 * registrando a data real de chegada — modal pequeno e específico, mesmo padrão de
 * RecolherParaRaroModal, em vez de abrir a edição completa (EditarEstadiaModal), que traz
 * campos que não fazem sentido reeditar nesse momento (motivo, forma de envio, cotado).
 */
export default function ConfirmarChegadaModal({ isOpen, onClose, estadia }: ConfirmarChegadaModalProps) {
  const { atualizarEstadia } = useEstadiaClienteMutations();

  const [data, setData] = useState('');

  const handleClose = () => {
    setData('');
    onClose();
  };

  const handleConfirmar = () => {
    atualizarEstadia.mutate(
      {
        id: estadia.id,
        status: 'em_homologacao',
        dataChegadaCliente: data ? Timestamp.fromDate(dataInputParaDate(data)) : Timestamp.now(),
      },
      { onSuccess: handleClose }
    );
  };

  return (
    <BaseModal isOpen={isOpen} onClose={handleClose} title="Confirmar chegada no Cliente" maxWidth="max-w-md" fullHeight={false}>
      <div className="space-y-4 py-4">
        <div>
          <label className="block text-sm font-medium text-gray-700">Data de chegada</label>
          <input type="date" className="input-primary mt-1 w-full" value={data} onChange={(event) => setData(event.target.value)} />
          <p className="mt-1 text-xs text-gray-500">Em branco, usa a data/hora de agora.</p>
        </div>

        <div className="flex justify-end gap-3">
          <button type="button" className="btn-secondary" onClick={handleClose}>
            Cancelar
          </button>
          <button type="button" className="btn-primary" onClick={handleConfirmar} disabled={atualizarEstadia.isPending}>
            {atualizarEstadia.isPending ? 'Salvando...' : 'Confirmar chegada'}
          </button>
        </div>
      </div>
    </BaseModal>
  );
}
